import React from 'react';
/*
import {
  ht,
  cr,
  gs,
  a,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  RootC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ht from './_ht';

import * as icm from './icm';
import * as ict from './ict';

import FtrC from './IccvFtr';

export const N = (pz: {
  cz: {
    bHome: ht.b,
    mode: ict.mode,
    pageName?: ht.s,
  },
  oClds: ht.ls,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`sc/lt1`),
        oClds: [

          cr.c(GridC.N, {
            key: -10,
            abtType: 'barHdrCmnz',
            boxStlz: a(`sc/rd7`),
            lineCs: [{
              cellCs: [
                {
                  oClds: [
                    pz.cz.bHome != false ?
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'hdrHomeCmnz',
                      boxStlz: a('pl/2'),
                      bfrIconCz: {},
                      lblCz: {},
                      pslPtyz: {
                        onPress: () => {
                          cr.moveTo({
                            pageName: 'icvHomeK10Rz',
                          });
                        }
                      },
                    })
                    : null,
                  ]
                },
                {
                  oClds: [
                    cr.c(TextC.N, {
                      key: -10,
                      abtType: 'hdrPageNameCmnz',
                      textz: {
                        pfx: pz.cz.pageName,
                      }
                    })
                  ]
                },
                {
                  oClds: [
                    cr.c(BtnC.N, {
                      key: -30,
                      abtType: 'hdrLgtCmnz',
                      boxStlz: a('pr/2'),
                      bfrIconCz: {},
                      lblCz: {},
                      pslPtyz: {
                        onPress: icm.lgt,
/*
                        () => {
                          _gUserz.rmvAsync()
                          .then(() => {
                            cr.moveTo({
                              pageName: 'Iccv31a',
                            })
                          });
                        }
*/
                      }
                    }),
                  ]
                },
              ],
            }]
          }),

          cr.c(BoxC.N, {
            key: -20,
            abtType: 'bdyCmnz',
            oClds: pz.oClds,
          }),

          cr.c(FtrC, {
            key: -30,
          })
        ],
      },
    })
  );
};
